import { useRootAppStore } from "@hooks";
import { getCurrentCulture } from "@utils";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function AnnualIncomeInfo() {
	const { t } = useTranslation("account-settings-navigation");
	const rootStore = useRootAppStore();

	if (!rootStore.userAuthStore.user?.isAnnualIncomeRequired) {
		return null;
	}

	return (
		<div className="popup__col col col-sml-12">
			<div className="message message--base">
				<div className="message__content u-padd--reset">
					<div className="message__title u-type--xmed">
						<i className="message__icon u-icon u-icon--lrg u-icon--income--alt u-color--sent--danger u-mar--right--tny" />
						<span className="u-align--v--middle">
							{t(
								"WELCOME_POPUP.ANNUAL_INCOME_AND_OCCUPATION_TITLE"
							)}
						</span>
					</div>

					<div className="message__text">
						{t("WELCOME_POPUP.ANNUAL_INCOME_AND_OCCUPATION_HINT")}
					</div>

					<Link
						className="at-welcomeModalBtnPD u-anchor u-anchor--primary u-anchor--underline has-arrow"
						to={`/${getCurrentCulture()}/${"account-settings/personal-data"}`}
						onClick={() => {
							rootStore.welcomeStore.hidePopup(),
								rootStore.requiredUserActionStore.hidePopup();
						}}
					>
						{t("account-settings-navigation:PERSONAL_DATA")}
					</Link>
				</div>
			</div>
		</div>
	);
}
